import React from "react";

const SearchResult = ({ searchMessage }) => {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only search-result"
    >
      {searchMessage}
    </div>
  );
};

export default SearchResult;
